import React, {FC, useEffect} from 'react';

import {IntegrationsType} from 'common/constants/success';
import {IntegrationResult} from 'common/models/success';
import i18n from 'ui/i18n';
import {actions, selectors, useAppDispatch, useAppSelector} from 'ui/store';
import {sendIntegrationResults} from 'ui/utils/postMessages';

import CollapsableCard from '../CollapsableCard';
import IntegrationItem from '../IntegrationItem';

import {IntegrationsProps} from './Integrations.types';

const {selectIntegrations} = selectors;
const {prepareIntegrations} = actions;

export const {iframe} = window.YC;
const CHECK_INTEGRATIONS_TIMEOUT = 3000;

const Integrations: FC<IntegrationsProps> = ({answerKey}) => {
    const dispatch = useAppDispatch();
    const integrationsData = useAppSelector(selectIntegrations);

    useEffect(() => {
        let timer: ReturnType<typeof setTimeout>;
        if (Object.values(integrationsData).some(({isSomePending}) => isSomePending)) {
            timer = setTimeout(
                () => dispatch(prepareIntegrations({answerKey})),
                CHECK_INTEGRATIONS_TIMEOUT,
            );
        } else if (iframe) {
            const results: IntegrationResult[] = [];
            [
                ...(integrationsData[IntegrationsType.Tracker]?.succeed ?? []),
                ...(integrationsData[IntegrationsType.Wiki]?.succeed ?? []),
            ].forEach((result) => {
                results.push({
                    type: result.type,
                    link: result.link,
                });
            });
            sendIntegrationResults(results);
        }

        return () => {
            clearTimeout(timer);
        };
    }, [answerKey, integrationsData]);

    return (
        <CollapsableCard title={i18n('success-page', 'title-integration')} uniqKey="integrations">
            {Object.values(IntegrationsType).map((key) => {
                const data = integrationsData[key];
                if (!data) {
                    return null;
                }

                return <IntegrationItem key={key} type={key} data={data} />;
            })}
        </CollapsableCard>
    );
};

export default Integrations;
